import { Box, Typography } from '@mui/material';

export const DataItem = ({
  label,
  value,
  preserveCase = false,
}: {
  label: string;
  value: any;
  preserveCase?: boolean;
}) => (
  <Box mb={2.5} className="data-item-box">
    <Typography
      variant="caption"
      sx={{
        color: '#64748b',
        fontWeight: 700,
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
        display: 'block',
        fontSize: '0.72rem',
        mb: 0.5,
      }}
    >
      {label}
    </Typography>
    <Typography
      variant="body1"
      sx={{
        color: '#1e293b',
        fontWeight: 600,
        wordBreak: 'break-word',
        lineHeight: 1.5,
        fontSize: '0.95rem',
        textTransform: preserveCase ? 'none' : 'capitalize',
      }}
    >
      {typeof value === 'string' ? (preserveCase ? value : value.toLowerCase()) : value || '-'}
    </Typography>
  </Box>
);
